export const toggleExclusiveLocationMarker = (locations, index, field) => {
  const enable = !Boolean(locations[index]?.[field]);
  return locations.map((row, idx) => ({
    ...row,
    [field]: enable && idx === index,
  }));
};

export const supplySelectionState = (mealSupplyModel) => ({
  meal_supply_model: mealSupplyModel,
  supply_setup_confirmed: Boolean(mealSupplyModel),
});

export const supplyOnboardingPatch = (mealSupplyModel) => ({
  profile: { meal_supply_model: mealSupplyModel },
  supply_setup_confirmed: Boolean(mealSupplyModel),
});
